import * as React from "react";

const Forbidden: React.SFC<{}> = props => <div>Forbidden</div>;

export default Forbidden;
